import { create } from 'zustand';
import { createRef } from 'react';
import { generateId } from '../services/random';
import TR from './../Trans';
import MuvikaService from './../services/muvika';
import accountStore from './account';
import messageStore from './message';

const initialState = {
  isWaiting: false,
  playLists: null
};

const bgPlaylistsStore = create((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  getPlayLists: (sessionToken) => {
    set({ isWaiting: true });
    MuvikaService.getMusicPlayLists(sessionToken)
      .then(function (res) {
        console.log(res);
        if (res.data.error) {
          set({ playLists: [], isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let playLists = [...res.data.data.items];
          for (let i = 0; i < playLists.length; i++) {
            let duration = 0;
            for (let j = 0; j < playLists[i].items.length; j++) {
              playLists[i].items[j].position = j;
              playLists[i].items[j].incoming = duration;
              duration += playLists[i].items[j].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
            }
          }
          set({ playLists: playLists, totalCount: res.data.data.items.length, isWaiting: false });
        }
      })
      .catch(function () { });
  },
  setPlayList: (sessionToken, playList) => {
    MuvikaService.setPlayList(sessionToken, playList)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          set({ playQueue: { ...playList } });
        }
      })
      .catch(function () { });
  },
  addToPlayList: (sessionToken, playListId, profile, track) => {
    let dateNow = new Date();
    dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
    let playLists = get().playLists;
    if (playLists) {
      let performance = {
        unique_id: generateId(8),
        created: dateNow,
        played: null,
        pitch: 0,
        track: track,
        profile: profile
      };
      let toPlayListId = playLists.findIndex(x => x.id == playListId);
      let toPlayList = playLists[toPlayListId];
      toPlayList.items.push(performance);
      let duration = 0;
      for (let i = 0; i < toPlayList.items.length; i++) {
        toPlayList.items[i].position = i;
        toPlayList.items[i].incoming = duration;
        duration += toPlayList.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
      }
      set({ playLists: [...playLists] });
      MuvikaService.setPlayList(sessionToken, toPlayList)
        .then(function (res) {
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            messageStore.getState().setMessage(sessionToken, TR.cm_added);
          }
        })
        .catch(function () { });
    }
  },
  createPlayList: (sessionToken, playListName) => {
    MuvikaService.createBackgroundMusicPlayList(sessionToken, playListName)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          let playLists = get().playLists;
          if (playLists) {
            let playListIndex = playLists.findIndex(x => x.name === playListName);
            if (playListIndex != -1) {
              messageStore.getState().setError(sessionToken, res.data.error.code, TR.cm_same_playlist_exists_already);
            } else {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            }
          } else {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          }
        } else {
          get().getPlayLists(sessionToken);
        }
      });
  }
}));

export default bgPlaylistsStore;